import {
  AccountGetResponse,
  MLSID,
  initialFTUXDictionary,
  isUndefined,
} from '@aloft/toolkit-shared';

import { RootState } from '../types.ts';

export const accountReqToState = (accountReq: AccountGetResponse): RootState['account'] => {
  const { id, email, body, userType, isAdmin } = accountReq;
  const {
    firstName,
    lastName,
    phone,
    mlsIDs,
    isOnboardingComplete,
    ftux,
    mcKissockData,
    signatureBlobId,
  } = body;

  return {
    id,
    email,
    firstName,
    lastName,
    phone,
    mlsIDs: (mlsIDs ?? []) as MLSID[],
    isOnboardingComplete: isUndefined(isOnboardingComplete) ? true : isOnboardingComplete,
    ftux: ftux ?? initialFTUXDictionary,
    mcKissockData,
    signatureBlobId,
    userType,
    isAdmin,
  };
};
